import React from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col } from 'antd';
import { ValidationFormStep1 } from './Step1.js';
import { ValidationFormStep2 } from './Step2.js';
import { ValidationFormStep3 } from './Step3.js';

class SaeRecording extends React.Component {


    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleSubmit(values)
            }
        });
    };

    handleNext = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleNext(values)

            }
        });
    };


    previousButton() {
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 2')) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.props.handlePrev}>
                    Back
                </Button>
            </Form.Item>
        )
      }

      return null;
    }

    nextButton(){
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 1')) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Next
                </Button>
            </Form.Item>
        )
      } else if (currentStep === 'Step 2')  {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Submit
                </Button>
            </Form.Item>
        )
      }

      return null;
    }



    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Row type='flex' justify='center'>
                <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                    <h2>SAE Recording - {this.props.currentStep}</h2>
                    <Form onSubmit={this.handleSubmit}>

                                          {/*
                                            Step 1 - user enters userID, siteID, subjectID
                                            Step 2 - verifies that userID, siteID are valid, that the subject exists, and if they already have validation data and consent, and asks the user whether the recommended randomization values have been used and whether and SAE has occurred
                                            Step 3 - user enters validation information
                                            Step 4 - Confirmation of validation process
                                          */}
                                          <ValidationFormStep1
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep2
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleSAEDatePickerChange={this.props.handleSAEDatePickerChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            validationExistsSAEOccurred={this.props.validationExistsSAEOccurred}
                                            isSAEOccurred={this.props.isSAEOccurred}
                                            validationExistsSAEType={this.props.validationExistsSAEType}
                                            saeDateInSiteTimezone={this.props.saeDateInSiteTimezone}
                                            validationExistsSAEDate={this.props.validationExistsSAEDate}
                                            validationExistsSAEDateMoment={this.props.validationExistsSAEDateMoment}
                                            validationExistsSAEComments={this.props.validationExistsSAEComments}
                                            other_event_comments={this.props.other_event_comments}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep3
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleSAEDatePickerChange={this.props.handleSAEDatePickerChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            validationExistsSAEOccurred={this.props.validationExistsSAEOccurred}
                                            validationExistsSAEType={this.props.validationExistsSAEType}
                                            validationExistsSAEDate={this.props.validationExistsSAEDate}
                                            validationExistsSAEDateMoment={this.props.validationExistsSAEDateMoment}
                                            validationExistsSAEComments={this.props.validationExistsSAEComments}
                                            other_event_comments={this.props.other_event_comments}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />

                                        {this.nextButton()}
                                        {this.previousButton()}


                    </Form>
                      <p>&nbsp;</p>
                      <h5>or select one of the following options:</h5>
                      <ul>
                        <li><Link to='/' style={{ color: '#FAFAFA', width: '12rem' }} className='menu-item'> Home </Link></li>
                      </ul>


                </Col>
            </Row>
        )
    }
}


const SaeRecordingForm = Form.create()(SaeRecording);

export default SaeRecordingForm;



// WEBPACK FOOTER //
// ./src/components/SaeRecording/SaeRecording.js